var _path, _path2, _path3, _path4, _path5, _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditarPrecioAsignacion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8169 13.8172C16.1395 11.4946 16.1395 7.62361 13.8169 5.30103",
    stroke: "#1A3D82",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.38744 5.38721C3.06486 7.70979 3.06486 11.5808 5.38744 13.9033",
    stroke: "#1A3D82",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.62402 10.9786C7.62402 11.7528 8.22617 12.3549 9.00037 12.3549H10.4627C11.0649 12.3549 11.667 11.8388 11.667 11.1506C11.667 10.3764 11.3229 10.1184 10.8928 9.94634L8.48424 9.08613C7.88209 9.0001 7.62402 8.74204 7.62402 8.05387C7.62402 7.36574 8.14015 6.84961 8.82832 6.84961H10.3767C11.1509 6.84961 11.7531 7.45176 11.7531 8.22591",
    stroke: "#1A3D82",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60205 5.98926V13.215",
    stroke: "#1A3D82",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60215 18.2043C14.3529 18.2043 18.2043 14.3529 18.2043 9.60215C18.2043 4.85131 14.3529 1 9.60215 1C4.85131 1 1 4.85131 1 9.60215C1 14.3529 4.85131 18.2043 9.60215 18.2043Z",
    stroke: "#1A3D82",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.6234,
    cy: 14.9784,
    r: 4.87634,
    fill: "white",
    stroke: "#1A3D82"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2060_7665)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1139 12.369C18.0089 12.264 17.8387 12.264 17.7337 12.369L17.4992 12.6035C17.1995 12.4603 16.8296 12.5129 16.5813 12.7612L13.73 15.6124L15.2507 17.1331L18.1019 14.2818C18.3502 14.0335 18.4028 13.6636 18.2596 13.3639L18.4941 13.1293C18.599 13.0244 18.599 12.8542 18.4941 12.7492L18.1139 12.369ZM16.9666 14.6568L15.2507 16.3727L14.4904 15.6124L16.2063 13.8965L16.9666 14.6568ZM17.4554 14.168L17.7218 13.9017C17.8267 13.7967 17.8267 13.6265 17.7218 13.5215L17.3416 13.1413C17.2366 13.0363 17.0664 13.0363 16.9614 13.1413L16.695 13.4077L17.4554 14.168Z",
    fill: "#1A3D82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9355 17.9221L13.5059 15.831L15.0265 17.3518L12.9355 17.9221Z",
    fill: "#1A3D82"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2060_7665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.45161,
    height: 6.45161,
    fill: "white",
    transform: "translate(12.3979 11.7527)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditarPrecioAsignacion);
export default __webpack_public_path__ + "static/media/editarPrecioAsignacion.e7a2aa17a0b97774ad60f601106e41ef.svg";
export { ForwardRef as ReactComponent };